// .c-accordion__panel {
//   max-height: 0;
//   overflow: hidden;
//   transition: max-height 0.4s ease;
// }

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-accordion').forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      event.preventDefault();

      const panel = accordion.nextElementSibling;

      if (accordion.parentElement.classList.contains('is-active')) {
        accordion.parentElement.classList.remove('is-active');
        panel.style.maxHeight = 0;
      } else {
        accordion.parentElement.classList.add('is-active');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});
